import { H2 } from "@blueprintjs/core";
import { setCurrentRoute, setPreviousRoute } from "controllers/common/action";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { constructPath, findRoute, routes } from "routes";
import { Analytics } from "utils/analytics";
import route from "./route";
export default function JournalArticals() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentRoute(route));
    Analytics.getInstance().pageview(constructPath(findRoute(routes, route.id)));
    return () => dispatch(setPreviousRoute(route));
  });
  return (
    <div className="publications">
      <H2> Journal Articles</H2>

      <ol>
        <li className="csl-entry">
          <a href="https://doi.org/10.1016/j.energy.2022.123638" target="_blank" rel="noreferrer">
            D. Wu, D. Wang, T. Ramachandran, and J. Holladay, “A techno-economic assessment framework for hydrogen
            energy storage toward multiple energy delivery pathways and grid services,” <cite>Energy</cite>, vol. 249,
            Jun. 2022, 122628.
          </a>
        </li>
        <li className="csl-entry">
          <a href="https://doi.org/10.1016/j.est.2022.104440" target="_blank" rel="noreferrer">
            X. Ma, D. Wu, D. Wang, B. Huang, K. Desomber, T. Fu, and M. Weimar, “Optimizing pumped storage hydropower
            for multiple grid services,” <cite>Journal of Energy Storage</cite>, May 2022.
          </a>
        </li>
        <li className="csl-entry">
          <a href="https://doi.org/10.1109/TSTE.2022.3148236" target="_blank" rel="noreferrer">
            Y. Du and D. Wu, “Deep reinforcement learning from demonstrations to assist service restoration in islanded
            microgrids,” <cite>IEEE Transactions on Sustainable Energy</cite>, vol.13, no. 2, pp. 1062–1072, Apr. 2022.
          </a>
        </li>
        <li id="ref-WuD21_Storage_review" className="csl-entry" role="doc-biblioentry">
          <a href="https://doi.org/10.1007/s40518-021-00181-9" target="_blank" rel="noreferrer">
            D. Wu and X. Ma, “Modeling and optimization methods for controlling and sizing grid-connected energy
            storage: A review,” <cite>Current Sustainable/Renewable Energy Reports</cite>, pp. 1–8, 2021.
          </a>
        </li>
        <li id="ref-WuD21_HECO" className="csl-entry" role="doc-biblioentry">
          <a href="https://doi.org/10.1016/j.apenergy.2021.116550" target="_blank" rel="noreferrer">
            D. Wu, X. Ma, P. Balducci, and D. Bhatnagar, “An economic assessment of behind-the-meter photovoltaics
            paired with batteries on the Hawaiian Islands,” <cite>Applied Energy</cite>, vol. 286, Mar. 2021, 116550.
          </a>
        </li>
        <li id="ref-WangJ21_TSTE" className="csl-entry" role="doc-biblioentry">
          <a href="https://doi.org/10.1109/TSTE.2020.2988513" target="_blank" rel="noreferrer">
            J. Wang, S. Huang, D. Wu, and N. Lu, “Operating a commercial building HVAC load as a virtual battery through
            airflow control,” <cite>IEEE Transactions on Sustainable Energy</cite>, vol. 12, no. 1, pp. 158–168, Jan.
            2021
          </a>
        </li>
        <li id="ref-HuangH20_regional_flexibility" className="csl-entry" role="doc-biblioentry">
          <a href="https://doi.org/10.1016/j.energy.2020.119571" target="_blank" rel="noreferrer">
            S. Huang, Y. Ye, D. Wu, and W. Zuo, “An assessment of power flexibility from commercial buildings in the
            United States,” <cite>Energy</cite>, 2020, 119571.
          </a>
        </li>
        <li id="ref-Baldu20_northampton" className="csl-entry" role="doc-biblioentry">
          <a href="https://doi.org/10.3390/en13184802" target="_blank" rel="noreferrer">
            P. Balducci, K. Mongird, D. Wu, D. Wang, V. Fotedar, and R. T. Dahowski, “An evaluation of the economic and
            resilience benefits of a microgrid in Northampton, Massachusetts,” <cite>Energies</cite>, vol. 13, 2020,
            4802.
          </a>
        </li>
        <li id="ref-WangP20_lock" className="csl-entry" role="doc-biblioentry">
          <a href="https://doi.org/10.1109/TSG.2020.2973186" target="_blank" rel="noreferrer">
            P. Wang, D. Wu, and K. Kalsi, “Flexibility estimation and control of thermostatically controlled loads with
            lock time for regulation service,”
            <cite>IEEE Transactions on Smart Grid</cite>, vol. 11, no. 4, pp. 3221–3230, Jul. 2020.
          </a>
        </li>
        <li id="ref-WuD20_EGY_DERsizing" className="csl-entry" role="doc-biblioentry">
          <a href="https://doi.org/10.1016/j.energy.2020.117284" target="_blank" rel="noreferrer">
            D. Wu, X. Ma, S. Huang, T. Fu, and P. Balducci, “Stochastic optimal sizing of distributed energy resources
            for a cost-effective and resilient microgrid,” <cite>Energy</cite>, vol. 198, May 2020, 117284.
          </a>
        </li>
        <li id="ref-YangT19_survey" className="csl-entry" role="doc-biblioentry">
          <a href="https://doi.org/10.1016/j.arcontrol.2019.05.006" target="_blank" rel="noreferrer">
            T. Yang, X. Yi, J. Wu, Y. Yu, D. Wu, Z. Meng, Y. Hong, H. Wang, Z. Lin, and K. H. Johansson, “A survey of
            distributed optimization,” <cite>Annual Reviews in Control</cite>, vol. 47, pp. 278–305, 2019.
          </a>
        </li>
        <li id="ref-Reima19" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/ACCESS.2019.2928568" target="_blank" rel="noreferrer">
            A. P. Reiman, A. Somani, M. J. E. Alam, P. Wang, D. Wu, and K. Kalsi, “Power factor correction in feeders
            with distributed photovoltaics using residential appliances as virtual batteries,” <cite>IEEE Access</cite>,
            vol. 7, pp. 99 115–99 122, 2019.
          </a>
        </li>
        <li id="ref-WuD19_APEN_PEV" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1016/j.apenergy.2019.113490" target="_blank" rel="noreferrer">
            D. Wu, N. Radhakrishnan, and S. Huang, “A hierarchical charging control of plug-in electric vehicles with
            simple flexibility model,” <cite>Applied Energy</cite>, vol. 253, p. 113490, Nov. 2019.
          </a>
        </li>
        <li id="ref-HuangS19" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1016/j.enbuild.2019.07.043" target="_blank" rel="noreferrer">
            S. Huang and D. Wu, “Validation on aggregate flexibility from residential air conditioning systems for
            building-to-grid integration,” <cite>Energy and Buildings</cite>, vol. 200, pp. 58–67, Oct. 2019.
          </a>
        </li>
        <li id="ref-YangT19_TCNS" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/TCNS.2019.2921284" target="_blank" rel="noreferrer">
            T. Yang, D. Wu, H. Fang, W. Ren, H. Wang, Y. Hong, and K. H. Johansson, “Distributed energy resources
            coordination over time-varying directed communication networks,”{" "}
            <cite>IEEE Transactions on Control of Network Systems</cite>, vol. 6, no. 3, pp. 1124–1134, Sep. 2019.
          </a>
        </li>
        <li id="ref-KeX19" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/TSG.2017.2754241" target="_blank" rel="noreferrer">
            X. Ke, D. Wu, and N. Lu, “A real-time greedy-index dispatching policy for using PEVs to provide frequency
            regulation service,” <cite>IEEE Transactions on Smart Grid</cite>, vol. 10, no. 1, pp. 864–877, Jan. 2019.
          </a>
        </li>
        <li id="ref-WuJ17" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/TSG.2017.2720761" target="_blank" rel="noreferrer">
            J. Wu, T. Yang, D. Wu, K. Kalsi, and K. H. Johansson, “Distributed optimal dispatch of distributed energy
            resources over lossy communication networks,” <cite>IEEE Transactions on Smart Grid</cite>, vol. 8, no. 6,
            pp. 3125–3137, Nov. 2018.
          </a>
        </li>
        <li id="ref-HaoH18_tsg_vritualbatt" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/TSG.2017.2655083" target="_blank" rel="noreferrer">
            H. Hao, D. Wu, J. Lian, and T. Yang, “Optimal coordination of building loads and energy storage for power
            grid and end user services,” <cite>IEEE Transactions on Smart Grid</cite>, vol. 9, no. 5, pp. 4335–4345,
            Sep. 2018.
          </a>
        </li>
        <li id="ref-Baldu18" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1039/C8EE00569A" target="_blank" rel="noreferrer">
            P. Balducci, J. Alam, T. Hardy, and D. Wu, “Assigning value to energy storage systems at multiple points in
            an electrical grid,” <cite>Energy & Environmental Science</cite>, vol. 11, no. 8, pp. 1926–1944, Jun. 2018.
          </a>
        </li>
        <li id="ref-JinS17_tsg_HPC" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/TSG.2016.2647220" target="_blank" rel="noreferrer">
            S. Jin, Z. Huang, R. Diao, D. Wu, and Y. Chen, “Comparative implementation of high performance computing for
            power system dynamic simulations,”
            <cite>IEEE Transactions on Smart Grid</cite>, vol. 8, no. 3, pp. 1387–1395, May 2017.
          </a>
        </li>
        <li id="ref-WuD17_EPSR" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1016/j.epsr.2017.05.002" target="_blank" rel="noreferrer">
            D. Wu, J. Lian, Y. Sun, T. Yang, and J. Hansen, “Hierarchical control framework for integrated coordination
            between distributed energy resources and demand response,” <cite>Electric Power Systems Research</cite>,
            vol. 150, pp. 45–54, Sep. 2017.
          </a>
        </li>
        <li id="ref-WuD17_EST_analytical_sizing" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1016/j.est.2017.04.009" target="_blank" rel="noreferrer">
            D. Wu, M. Kintner-Meyer, T. Yang, and P. Balducci, “Analytical sizing methods for behind-the-meter battery
            storage,” <cite>Journal of Energy Storage</cite>, vol. 12, pp. 297–304, Aug. 2017.
          </a>
        </li>
        <li id="ref-YangT17_tie" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/TIE.2016.2617832" target="_blank" rel="noreferrer">
            T. Yang, J. Lu, D. Wu, J. Wu, G. Shi, Z. Meng, and K. H. Johansson, “A distributed algorithm for economic
            dispatch over time-varying directed networks with delays,”{" "}
            <cite>IEEE Transactions on Industrial Electronics</cite>, vol. 64, no. 6, pp. 5095–5106, Jun. 2017.
          </a>
        </li>
        <li id="ref-WuD17_TASE" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/TASE.2016.2627006" target="_blank" rel="noreferrer">
            D. Wu, T. Yang, A. A. Stoorvogel, and J. Stoustrup, “Distributed optimal coordination for distributed energy
            resources in power systems,”
            <cite>IEEE Transactions on Automation Science and Engineering</cite>, vol. 14, no. 2, pp. 414–424, Apr.
            2017.
          </a>
        </li>
        <li id="ref-YangT16_tie" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/TIE.2015.2504050" target="_blank" rel="noreferrer">
            T. Yang, D. Wu, Y. Sun, and J. Lian, “Minimum-time consensus based approach for power system applications,”{" "}
            <cite>IEEE Transactions on Industrial Electronics</cite>, vol. 63, no. 2, pp. 1318–1328, Feb. 2016.
          </a>
        </li>
      </ol>
    </div>
  );
}
